export default "__VITE_ASSET__WT_5M899__"